<header class="col-12 p-0 header-page">
  <section class="col-xl-8 header-page-title">
    <h1 class="header__page__content__title">
      Prova de Vida
    </h1>
    <!-- <h2 class="header__page__content__subtitle">
            Minha prova de vida
        </h2> -->
  </section>
  <section class="col-xl-4 header__page__img">
    <img class="header__page__img__prova"
      [src]="provaVida ? '../../../../../../assets/img/png/prova-vida-ok.png' : '../../../../../../assets/img/png/prova-vida.png' "
      [alt]="provaVida ? 'Prova de vida realizada' : 'Prova de vida não realizada'" (click)="provaVidaValidacao()">
  </section>
</header>
<main class="col-sm-12 col-xl-12 main__content">
  <section class="content__main">
    <section class="main__content__form">
      <form [formGroup]="formData" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 content__form">
        <div class="col-xl-5 p-0">
          <label class="label__form">Selecione uma opção
            <span class="label__form__required">*</span>
          </label>
          <ng-select bindLabel="nome" bindValue="id" formControlName="provaVidaId" placeholder="Selecione"
            (change)="lifeTestChanged($event)" [clearable]="false" [items]="tipoProvaVida">
          </ng-select>
          <div>
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('provaVidaId')?.touched && formData.get('provaVidaId')?.invalid">
              Por favor, selecione ao menos um tipo
            </small>
          </div>
        </div>
      </form>
    </section>
    <aviso [textoAviso]="dataProvaVida 
                ? 'Prova de Vida realizada em: ' + {dataProvaVida} 
                : 'Você não realizou sua prova de vida!'" *ngIf="!formData.get('provaVidaId')?.value">
    </aviso>
    <section class="main__content__fc"
      *ngIf="formData.get('provaVidaId')?.value == 1 && formData.get('provaVidaId')?.valid">
      <h3>Documentos necessários</h3>
      <ul class="content__fc__lista">
        <li data-number>
          Tire um foto da parte da frente e verso do seu RG ou CNH! O documento a ser anexado deve estar legível!
          Caso você escolha tirar uma foto direto pelo site, aqui estão algumas dicas para a sua selfie ficar perfeita!
        </li>
        <li data-number>
          Providencie um local bem iluminado!
        </li>
        <li data-number>
          Evite sombras fortes em seu rosto e atrás dele!
        </li>
        <li data-number>
          Mantenha os olhos abertos e olhe para a câmera!
        </li>
      </ul>
      <section class="content-form">
        <section>
          <section class="col-xl-5 content-form-field">
            <form-input [labelInput]="'Foto frente e verso do seu RG ou CNH'" [isRequired]="true" [tipoDocumento]="'rg'"
              [formFiles]="formData.get('documentoPessoaFisicaFiles.files')?.value"
              (adicionar)="addDocumentosPessoais($event)">
            </form-input>
            <button type="submit" class="btn btn-primary btn-camera" (click)="takePhoto('documentoPessoaFisicaFiles')">
              <fa-icon [icon]="faCamera" size="1x" class="form-prova-vida-icone"></fa-icon>
            </button>
          </section>
          <section class="col-xl-12 p-0 content-form-lista">
            <div class="lista-row"
              *ngFor="let itemFile of this.formData.get('documentoPessoaFisicaFiles.files')?.value; let i = index">
              <span>
                {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
              </span>
              <div class="lista-actions">
                <fa-icon class="card__header__icon lista-btn-close" size="2x"
                  (click)="removeFile('documentoPessoaFisicaFiles',i)" [icon]="faSquareXmark"></fa-icon>
              </div>
            </div>
          </section>
        </section>
        <section>
          <section class="col-xl-5 content-form-field">
            <form-input [labelInput]="'Anexar selfie'" [isRequired]="true" [tipoDocumento]="'selfie'"
              [formFiles]="formData.get('selfie.files')?.value" (adicionar)="addSelfie($event)">
            </form-input>
            <button type="submit" class="btn btn-primary btn-camera" (click)="takePhoto('selfie')">
              <fa-icon [icon]="faCamera" size="1x" class="form-prova-vida-icone"></fa-icon>
            </button>
          </section>
          <section class="col-xl-12 p-0 content-form-lista">
            <div class="lista-row" *ngFor="let itemFile of this.formData.get('selfie.files')?.value; let i = index">
              <span>
                {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
              </span>
              <div class="lista-actions">
                <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removeFile('selfie',i)"
                  [icon]="faSquareXmark"></fa-icon>
              </div>
            </div>
          </section>
        </section>
        <br>
        <section class="col-12 p-0">
          <button type="submit" class="btn btn-primary btn-block col-xl-2 col-lg-3 col-md-4 col-sm-12 float-right"
            (click)="solicitaProvaVida(
                    'Fundacao')"
            [disabled]="this.formData.get('selfie.files')?.value <= 0 || this.formData.get('documentoPessoaFisicaFiles.files')?.value <= 0">
            <div class="spinner-border" role="status" *ngIf="loading; else showSpan" [@fadeInOut]>
              <span class="sr-only">Solicitando</span>
            </div>
            <ng-template #showSpan>
              <span>Solicitar</span>
            </ng-template>
          </button>
        </section>
      </section>
    </section>
    <section class="main__content__fc" *ngIf="formData.get('provaVidaId')?.value == 2
            && formData.get('provaVidaId')?.valid">
      <h3>Documentos necessários</h3>
      <section class="content-form">
        <section>
          <section class="col-xl-5 content-form-field">
            <form-input [labelInput]="'Anexe a Prova de Vida realizada no INSS nos últimos 6 meses'" [isRequired]="true"
              [tipoDocumento]="'INSS'" [formFiles]="formData.get('provaVidaInssFiles.files')?.value"
              (adicionar)="addDocInss($event)">
            </form-input>
          </section>
        </section>
        <section class="col-xl-12 p-0 content-form-lista">
          <div class="lista-row"
            *ngFor="let itemFile of this.formData.get('provaVidaInssFiles.files')?.value; let i = index">
            <span>
              {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
            </span>
            <div class="lista-actions">
              <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removeFile('provaVidaInssFiles',i)"
                [icon]="faSquareXmark"></fa-icon>
            </div>
          </div>
        </section>
      </section>
      <section class="col-12 p-0">
        <button type="submit" class="btn btn-primary btn-block col-xl-2 col-lg-3 col-md-4 col-sm-12 float-right"
          (click)="solicitaProvaVida('INSS')"
          [disabled]="this.loading || this.formData.get('provaVidaInssFiles.files')?.value <= 0">
          <div class="spinner-border" role="status" *ngIf="loading; else showSpan" [@fadeInOut]>
            <span class="sr-only">Solicitando</span>
          </div>
          <ng-template #showSpan>
            <span>Solicitar</span>
          </ng-template>
        </button>
      </section>
    </section>
  </section>
</main>